export interface Operator {
  id?: number,
  label: string,
  value?: string,
}

// Servicio de themas
export interface IThemeColors {
  primary: string;                   // Color primario
  secondary: string;                 // Color secundario
  tertiary: string;                  // Color terciario
  bodyBackgroundColor: string;       // Color de fondo del cuerpo
  secondaryBackground: string;      // Color de fondo secundario

  hover: string;                     // Color de hover
  focus: string;                     // Color de foco

  border: string;                    // Color de borde
  borderHover: string;               // Color de borde al pasar el mouse

  buttonPrimary: string;             // Color de botón primario
  buttonPrimaryHover: string;        // Color de hover para botón primario
  buttonSecondary: string;           // Color de botón secundario
  buttonSecondaryHover: string;      // Color de hover para botón secundario
  buttonDanger: string;              // Color de botón peligro
  buttonDangerHover: string;         // Color de hover para botón peligro
  buttonText: string;                // Color de texto del botón
  buttonDisabled: string;                // Color de texto del botón desabilitado

  cardBackground: string;            // Color de fondo de tarjetas
  cardShadow: string;                // Sombra de tarjetas
  cardBorder: string;                // Borde de tarjetas

  loadingSpinner: string;            // Color de spinner de carga
  disabled: string;                  // Color de elementos deshabilitados

  headerBackground: string;          // Color de fondo del encabezado
  footerBackground: string;          // Color de fondo del pie de página
  footerText: string;                // Color de texto del pie de página

  infoBackground: string;            // Color de fondo para información
  infoText: string;                  // Color de texto para información
  successBackground: string;         // Color de fondo de éxito
  successText: string;               // Color de texto de éxito
  warningBackground: string;         // Color de fondo de advertencia
  warningText: string;               // Color de texto de advertencia
  errorBackground: string;           // Color de fondo de error
  errorText: string;                 // Color de texto de error

  textPrimary: string;               // Color de texto primario
  textSecondary: string;             // Color de texto secundario
  textContrast: string;              // Color de texto con alto contraste

  linkText: string;                  // Color de texto de enlaces
}
export enum CSSVariables {
  GL_PRIMARY = '--gl-primary',
  GL_SECONDARY = '--gl-secondary',
  GL_TERTIARY = '--gl-tertiary',
  GL_BODY_BACKGROUND_COLOR = '--gl-body-background-color',
  GL_SECONDARY_BACKGROUND = '--gl-secondary-background',

  GL_HOVER = '--gl-hover',
  GL_FOCUS = '--gl-focus',

  GL_BORDER = '--gl-border',
  GL_BORDER_HOVER = '--gl-border-hover',

  GL_BUTTON_PRIMARY = '--gl-button-primary',
  GL_BUTTON_PRIMARY_HOVER = '--gl-button-primary-hover',
  GL_BUTTON_SECONDARY = '--gl-button-secondary',
  GL_BUTTON_SECONDARY_HOVER = '--gl-button-secondary-hover',
  GL_BUTTON_DANGER = '--gl-button-danger',
  GL_BUTTON_DANGER_HOVER = '--gl-button-danger-hover',
  GL_BUTTON_TEXT = '--gl-button-text',
  GL_BUTTON_DISABLED = '--gl-button-disabled',

  GL_CARD_BACKGROUND = '--gl-card-background',
  GL_CARD_SHADOW = '--gl-card-shadow',
  GL_CARD_BORDER = '--gl-card-border',

  GL_LOADING_SPINNER = '--gl-loading-spinner',
  GL_DISABLED = '--gl-disabled',

  GL_HEADER_BACKGROUND = '--gl-header-background',
  GL_FOOTER_BACKGROUND = '--gl-footer-background',
  GL_FOOTER_TEXT = '--gl-footer-text',

  GL_INFO_BACKGROUND = '--gl-info-background',
  GL_INFO_TEXT = '--gl-info-text',
  GL_SUCCESS_BACKGROUND = '--gl-success-background',
  GL_SUCCESS_TEXT = '--gl-success-text',
  GL_WARNING_BACKGROUND = '--gl-warning-background',
  GL_WARNING_TEXT = '--gl-warning-text',
  GL_ERROR_BACKGROUND = '--gl-error-background',
  GL_ERROR_TEXT = '--gl-error-text',

  GL_TEXT_PRIMARY = '--gl-text-primary',
  GL_TEXT_SECONDARY = '--gl-text-secondary',
  GL_TEXT_CONTRAST = '--gl-text-contrast',

  GL_LINK_TEXT = '--gl-link-text'
}
